import React, { forwardRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Box, Typography } from "@mui/material";
import { CalendarToday } from "@mui/icons-material";

// Inject clean theme using <style> so everything is in ONE FILE
const datePickerTheme = `
/* Popper container - ensure high z-index */
.react-datepicker-popper {
  z-index: 9999 !important;
}

/* Clean DatePicker Popup Container */
.react-datepicker {
  border: 1px solid #e5e7eb !important;
  border-radius: 10px !important;
  background-color: #ffffff !important;
  box-shadow: 0 6px 20px rgba(0,0,0,0.15) !important;
  padding-top: 4px;
  font-family: inherit !important;
}

/* Header */
.react-datepicker__header {
  background-color: #f8f9fa !important;
  border-bottom: 1px solid #e5e7eb !important;
  border-radius: 10px 10px 0 0 !important;
  padding-top: 8px !important;
}

.react-datepicker__current-month {
  font-weight: 600 !important;
  color: #374151 !important;
}

/* Weekday Row Fix + Alignment */
.react-datepicker__day-names {
  margin-top: 4px !important;
  display: flex !important;
  justify-content: space-around !important;
}

/* Weekday (Mon, Tue, Wed) */
.react-datepicker__day-name {
  width: 2.2rem !important;
  margin: 0 !important;
  text-align: center !important;
  font-size: 12px !important;
  color: #6b7280 !important;
  font-weight: 600 !important;
}

/* Day cells */
.react-datepicker__day {
  width: 2.2rem !important;
  line-height: 2.2rem !important;
  margin: 4px !important;
  border-radius: 6px !important;
  font-size: 14px !important;
  color: #374151 !important;
  text-align: center !important;
}

/* Hover */
.react-datepicker__day:hover {
  background-color: #e5e7eb !important;
}

/* Selected day */
.react-datepicker__day--selected {
  background-color: #40518A !important;
  color: white !important;
  font-weight: 600;
}

/* Today */
.react-datepicker__day--today {
  border: 1px solid #40518A !important;
  font-weight: bold !important;
}

/* ============================================= */
/* REMOVE ALL BORDERS FROM MONTH & YEAR DROPDOWN */
/* ============================================= */

/* Top dropdown container */
.react-datepicker__header__dropdown {
  border: none !important;
  outline: none !important;
  background: transparent !important;
  box-shadow: none !important;
}

/* Month & Year read view (visible dropdown button) */
.react-datepicker__month-read-view,
.react-datepicker__year-read-view {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  background: transparent !important;
  padding: 4px 8px !important;
  display: flex !important;
  align-items: center !important;
  cursor: pointer !important;
}

/* Remove border when clicked or selected */
.react-datepicker__month-read-view--selected-month,
.react-datepicker__year-read-view--selected-year {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
}

/* Remove border on hover */
.react-datepicker__month-read-view:hover,
.react-datepicker__year-read-view:hover {
  background: rgba(0,0,0,0.04) !important;
  border: none !important;
  outline: none !important;
}

/* Remove border on focus */
.react-datepicker__month-read-view:focus,
.react-datepicker__year-read-view:focus {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
}

/* Remove border when active */
.react-datepicker__month-read-view:active,
.react-datepicker__year-read-view:active {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
}

/* Dropdown popup menu (month/year list) */
.react-datepicker__month-dropdown,
.react-datepicker__year-dropdown {
  border: none !important;
  outline: none !important;
  background: white !important;
  border-radius: 8px !important;
  box-shadow: 0 6px 20px rgba(0,0,0,0.15) !important;
}

/* Dropdown options */
.react-datepicker__month-option,
.react-datepicker__year-option {
  padding: 6px 12px !important;
  border: none !important;
  outline: none !important;
}

.react-datepicker__month-option:hover,
.react-datepicker__year-option:hover {
  background: #e5e7eb !important;
  border: none !important;
  outline: none !important;
}

.react-datepicker__month-option:focus,
.react-datepicker__year-option:focus {
  border: none !important;
  outline: none !important;
}

/* Selected option in dropdown */
.react-datepicker__month-option--selected,
.react-datepicker__year-option--selected {
  border: none !important;
  outline: none !important;
}

/* Arrow icon color */
.react-datepicker__month-read-view--down-arrow,
.react-datepicker__year-read-view--down-arrow {
  border-top-color: #40518A !important;
}

/* ============================================= */
/* SELECT DROPDOWN STYLES (for dropdownMode="select") */
/* ============================================= */

/* Month and Year select containers */
.react-datepicker__month-dropdown-container--select,
.react-datepicker__year-dropdown-container--select {
  margin: 0 4px !important;
}

/* Style the native select elements */
.react-datepicker__month-select,
.react-datepicker__year-select {
  padding: 6px 24px 6px 10px !important;
  border: 1px solid #e5e7eb !important;
  border-radius: 6px !important;
  background-color: #ffffff !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  color: #374151 !important;
  cursor: pointer !important;
  outline: none !important;
  appearance: none !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23374151' d='M2 4l4 4 4-4z'/%3E%3C/svg%3E") !important;
  background-repeat: no-repeat !important;
  background-position: right 8px center !important;
  background-size: 12px !important;
  min-width: 80px !important;
}

.react-datepicker__month-select:hover,
.react-datepicker__year-select:hover {
  border-color: #40518A !important;
  box-shadow: 0 0 0 2px rgba(64, 81, 138, 0.1) !important;
}

.react-datepicker__month-select:focus,
.react-datepicker__year-select:focus {
  border-color: #40518A !important;
  box-shadow: 0 0 0 2px rgba(64, 81, 138, 0.2) !important;
}

/* Navigation arrows */
.react-datepicker__navigation {
  top: 12px !important;
}

.react-datepicker__navigation--previous {
  left: 10px !important;
}

.react-datepicker__navigation--next {
  right: 10px !important;
}

.react-datepicker__navigation-icon::before {
  border-color: #40518A !important;
}

.react-datepicker__navigation:hover .react-datepicker__navigation-icon::before {
  border-color: #2d3961 !important;
}

/* Disabled days */
.react-datepicker__day--disabled {
  color: #cbd5e0 !important;
  cursor: not-allowed !important;
}

.react-datepicker__day--disabled:hover {
  background-color: transparent !important;
}

/* Outside month days */
.react-datepicker__day--outside-month {
  color: #a0aec0 !important;
}

/* Week container for proper alignment */
.react-datepicker__week {
  display: flex !important;
  justify-content: space-around !important;
}

/* Month container */
.react-datepicker__month {
  margin: 8px !important;
}

/* Popper arrow */
.react-datepicker__triangle {
  display: none !important;
}

/* Custom popper class */
.datepicker-popper {
  z-index: 9999 !important;
}
`;

// Custom Input for React DatePicker
const CustomInput = forwardRef(({ value, onClick }, ref) => (
  <Box
    onClick={onClick}
    ref={ref}
    sx={{
      display: "flex",
      alignItems: "center",
      gap: 1,
      padding: "10px 12px",
      borderRadius: "8px",
      border: "1px solid #ccc",
      cursor: "pointer",
      width: "100%",
      fontSize: "14px",
      backgroundColor: "#f8f9fa",
      transition: "0.2s",
      "&:hover": {
        borderColor: "#40518A",
        boxShadow: "0 0 6px rgba(64,81,138,0.3)",
      },
    }}
  >
    <CalendarToday sx={{ fontSize: 18, color: "#40518A" }} />
    <Typography sx={{ fontSize: 14, color: "#333" }}>
      {value}
    </Typography>
  </Box>
));

const SingleDatePicker = forwardRef(({
  selectedDate,
  onChange,
  disableFuture = false,
  maxDate,
  ...datePickerProps
}, ref) => {
  const effectiveDate =
    selectedDate && !Number.isNaN(selectedDate.getTime())
      ? selectedDate
      : new Date();

  const effectiveMaxDate = disableFuture ? new Date() : maxDate;

  const handleChange = (date) => {
    if (!date || Number.isNaN(date.getTime())) return;
    if (effectiveMaxDate && date > effectiveMaxDate) return;
    if (onChange) {
      onChange(date);
    }
  };

  return (
    <>
      {/* Inject theme */}
      <style>{datePickerTheme}</style>

      <Box sx={{ display: "flex", flexDirection: "column", gap: 0, position: "relative" }}>
        <DatePicker
          ref={ref}
          selected={effectiveDate}
          onChange={handleChange}
          dateFormat="MMM dd, yyyy"
          customInput={<CustomInput />}
          showMonthDropdown
          showYearDropdown
          dropdownMode="select"
          formatWeekDay={(nameOfDay) => nameOfDay.slice(0, 3)}
          maxDate={effectiveMaxDate}
          popperClassName="datepicker-popper"
          {...datePickerProps}
        />
      </Box>
    </>
  );
});

export default SingleDatePicker;
